module.exports = __webpack_public_path__ + "static/media/countries.45d620e1.JPG";